import { FC, Fragment } from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { NumberInput } from "../core/NumberField";
import { useStyles } from "../../useStyles";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { BuildingIcon } from "../core/icons/Icons";
import { InputLabel } from "@material-ui/core";

export const AdjustableLoadElectricBusinessDemandForm: FC = () => {
    const classes = useStyles();
    const { values, setValues } = useFormModel<ChangeNames.ADJUSTABLE_LOAD_ELECTRICAL_BUSINESS_DEMAND>();

    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<BuildingIcon />}
                content={
                    <Fragment>
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Gleichzeitig benötigte Gewerbeleistung
                        </p>
                        <p className={classes.p} style={{ marginTop: 0, marginBottom: 24 }}>
                            Geben Sie die gleichzeitig benötigte Gewerbeleistung an. Die benötigte
                            Leistung erhalten Sie ggf. von Ihrem Elektroinstallateur.
                        </p>
                        <InputLabel className={classes.labledTextfieldLabel}>
                            Summe der Gewerbeleistung
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            decimalScale={values.adjustableLoadElectricBusinessDemand.value.precision}
                            allowLeadingZeros={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={values.adjustableLoadElectricBusinessDemand.value.unit}
                            value={values.adjustableLoadElectricBusinessDemand.value.amount.num || ""}
                            placeholder="0"
                            onValueChange={v =>
                                setValues(values => {
                                    values.adjustableLoadElectricBusinessDemand.value.amount.num =
                                        v.floatValue || null;
                                })
                            }
                            error={Boolean(values.adjustableLoadElectricBusinessDemand.error)}
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
};
